import React from 'react';
import { ChallengeNotificationPage } from "../StaticNotification";
import SendCongratsButton from "../SendCongratsButton";

const ColleaguesList = ({ colleagues, congratulationStatus, onCongratsSent }) => {
  return colleagues.map((colleague) => (
    <div key={colleague.id} className="challenge-completed-item">
      <ChallengeNotificationPage name={colleague.name} />
      <SendCongratsButton 
        userId={colleague.id}
        onCongratsSent={() => onCongratsSent(colleague.id)}
        initialCongratsSent={congratulationStatus[colleague.id]}
      />
    </div>
  ));
};

export default ColleaguesList; 